export default function getResource(label, vars = []) {
    const resources = {
        installmentsWithAfterpayAndKlarna: `ou quatre paiements de ${vars[0]} avec`,
        or: 'ou ',
        testCardDiscount: `ou une réduction de ${vars[0]} $ sur votre commande Sephora lors de l’ouverture et l’utilisation de votre carte de crédit Sephora dès aujourd’hui¹.`,
        test: 'Obtenez 2x les points Beauty Insider pour chaque dollar dépensé avec votre carte de crédit Sephora chez Sephora.',
        testSeeDetails: 'Voir les détails',
        learnMore: 'En savoir plus',
        openBuyNowPayLater: `Ouvrir la modalité acheter maintenant payer plus tard ${vars[0]}`
    };

    return resources[label];
}
